var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPop2WinRightDoor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 30 30",
    style: {
      enableBackground: "new 0 0 30 30"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M24.6,30H5.4V0h19.3V30z M6.3,29h17.3V1H6.3V29z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6,25.3H9.4V4.7h11.2V25.3z M10.3,24.4h9.3V5.6h-9.3V24.4z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.1,
    y: 11.7,
    transform: "matrix(0.7235 -0.6903 0.6903 0.7235 -10.6248 17.5232)",
    width: 1,
    height: 20.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.5,
    y: 7,
    transform: "matrix(0.7129 -0.7012 0.7012 0.7129 -0.5111 13.7703)",
    width: 20,
    height: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.6,
    cy: 14.5,
    rx: 2.2,
    ry: 2.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7,29.6c-0.2,0-0.4-0.1-0.5-0.4l-0.4-1.6c-0.1-0.3,0.1-0.5,0.3-0.6c0.3-0.1,0.5,0.1,0.6,0.3l0.4,1.6 c0.1,0.3-0.1,0.5-0.3,0.6L23.7,29.6z M22.5,25.2c-0.2,0-0.4-0.1-0.5-0.4l-1-3.7c-0.1-0.3,0.1-0.5,0.3-0.6c0.3-0.1,0.5,0.1,0.6,0.3 l1,3.7c0.1,0.3-0.1,0.5-0.3,0.6L22.5,25.2z M20.7,18.7c-0.2,0-0.4-0.1-0.5-0.4l-1-3.7c-0.1-0.3,0.1-0.5,0.3-0.6 c0.3-0.1,0.5,0.1,0.6,0.3l1,3.7c0.1,0.3-0.1,0.5-0.3,0.6L20.7,18.7z M18.9,12.1c-0.2,0-0.4-0.1-0.5-0.4l-1-3.7 c-0.1-0.3,0.1-0.5,0.3-0.6c0.3-0.1,0.5,0.1,0.6,0.3l1,3.7c0.1,0.3-0.1,0.5-0.3,0.6L18.9,12.1z M17.1,5.6c-0.2,0-0.4-0.1-0.5-0.4 l-1-3.7C15.6,1.2,15.7,1,16,0.9c0.3-0.1,0.5,0.1,0.6,0.3l1,3.7c0.1,0.3-0.1,0.5-0.3,0.6L17.1,5.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.8,29.6l-0.2,0c-0.3-0.1-0.4-0.4-0.3-0.6l1.3-3.6C6.8,25,7,24.9,7.3,25c0.3,0.1,0.4,0.4,0.3,0.6l-1.3,3.6 C6.2,29.4,6,29.6,5.8,29.6z M8.1,23.2l-0.2,0c-0.3-0.1-0.4-0.4-0.3-0.6l1.3-3.6c0.1-0.3,0.4-0.4,0.6-0.3c0.3,0.1,0.4,0.4,0.3,0.6 l-1.3,3.6C8.5,23,8.3,23.2,8.1,23.2z M10.4,16.8l-0.2,0c-0.3-0.1-0.4-0.4-0.3-0.6l1.3-3.6c0.1-0.3,0.4-0.4,0.6-0.3 c0.3,0.1,0.4,0.4,0.3,0.6l-1.3,3.6C10.8,16.7,10.6,16.8,10.4,16.8z M12.6,10.4l-0.2,0c-0.3-0.1-0.4-0.4-0.3-0.6l1.3-3.6 c0.1-0.3,0.4-0.4,0.6-0.3c0.3,0.1,0.4,0.4,0.3,0.6l-1.3,3.6C13,10.3,12.8,10.4,12.6,10.4z M14.9,4l-0.2,0c-0.3-0.1-0.4-0.4-0.3-0.6 l0.8-2.2c0.1-0.3,0.4-0.4,0.6-0.3c0.3,0.1,0.4,0.4,0.3,0.6l-0.8,2.2C15.3,3.9,15.1,4,14.9,4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPop2WinRightDoor);
export default __webpack_public_path__ + "static/media/pop_2win_right_door.9810478d8c93e25a316d6898b5ba43be.svg";
export { ForwardRef as ReactComponent };